import { render, staticRenderFns } from "./JoinGroupChatCrousel.vue?vue&type=template&id=247713d0&"
import script from "./JoinGroupChatCrousel.vue?vue&type=script&lang=js&"
export * from "./JoinGroupChatCrousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports